import { c as _c } from "react/compiler-runtime";
import useReviewsHasFilters from '../../context/useReviewsHasFilters';
import ExperienceFilter from './ExperienceFilter';
import OccasionFilter from './OccasionFilter';
const ReviewsFilters = t0 => {
    const $ = _c(11);
    const { formId, disabled } = t0;
    const { hasOccasionFilter, hasExperienceFilter } = useReviewsHasFilters();
    let t1;
    if ($[0] !== disabled || $[1] !== formId || $[2] !== hasExperienceFilter) {
        t1 = hasExperienceFilter ? <ExperienceFilter formId={formId} disabled={disabled}/> : null;
        $[0] = disabled;
        $[1] = formId;
        $[2] = hasExperienceFilter;
        $[3] = t1;
    }
    else {
        t1 = $[3];
    }
    let t2;
    if ($[4] !== disabled || $[5] !== formId || $[6] !== hasOccasionFilter) {
        t2 = hasOccasionFilter ? <OccasionFilter formId={formId} disabled={disabled}/> : null;
        $[4] = disabled;
        $[5] = formId;
        $[6] = hasOccasionFilter;
        $[7] = t2;
    }
    else {
        t2 = $[7];
    }
    let t3;
    if ($[8] !== t1 || $[9] !== t2) {
        t3 = <>{t1}{t2}</>;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
    }
    else {
        t3 = $[10];
    }
    return t3;
};
export default ReviewsFilters;
